import { ensureSmoothScroll, getSmoothScroll } from '../adapters/legacy-vendors.js';

function gotoBlock(targetBlock, speed, offset = 150) {
  const SmoothScroll = getSmoothScroll();
  if (!targetBlock || typeof SmoothScroll !== 'function') {
    return;
  }

  const scroll = new SmoothScroll();
  scroll.animateScroll(targetBlock, '', {
    speedAsDuration: true,
    speed,
    header: '',
    offset,
    easing: 'easeOutQuad',
  });
}

export async function initSmoothScroll() {
  if (document.querySelector('._goto')) {
    await ensureSmoothScroll().catch(() => null);
  }

  document.querySelectorAll('._goto').forEach((link) => {
    if (link.dataset.webtenseGotoInit) {
      return;
    }

    link.dataset.webtenseGotoInit = 'true';
    link.addEventListener('click', (event) => {
      const targetClass = link.getAttribute('href').replace('#', '');
      gotoBlock(document.querySelector(`#${targetClass}`), 300);
      event.preventDefault();
    });
  });

  if (document.documentElement.dataset.webtenseSmoothScrollInit) {
    return;
  }

  document.documentElement.dataset.webtenseSmoothScrollInit = 'true';
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-go-scroll]');
    if (!link) {
      return;
    }

    event.preventDefault();
    const target = document.querySelector(link.getAttribute('data-go-scroll'));
    if (!target) {
      return;
    }

    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY,
      behavior: 'smooth',
    });
  });
}
